<template> 
<!--Navbar -->
<!-- As a link -->
   <div class= "comm_navbar">
      <b-navbar   type="light" variant="light">
         <div class="navbar-brand" >
               <!-- <img src="../assets/images/qaller.png" width="90"   class="d-inline-block align-top" alt=""> -->
               <p class="talk">Talk</p> 
         </div>
            <b-collapse id="nav-collapse" is-nav>
               <b-navbar-nav class="ml-auto">
                  <div style="position: relative;margin-left: 10px;display: contents;" >
                     <div class="mic_input" > 
                        <canvas id="mic_input" ref="mic_input" width="40" height="85"  ></canvas> 
                     </div>
                     <div class="mic_image">
                        <img style="height:25px" src="../assets/images/mic.png">
                     </div>
                  </div>
                  <div class="sign_out" v-on:click="signout"> 
                     {{username}} 
                     <br>
                     Log Out 
                  </div>
               </b-navbar-nav>
         </b-collapse>
      </b-navbar>
   </div>
</template> 

<script>
   export default {
      name: 'navr',
      props: {
         username: String,
         canvas: Object,
         studiocaller : Object,
      },
      mounted: function() {
         this.canvas.create_canvas(this.$refs["mic_input"]);
      },
      methods:  {
         signout() {
             localStorage.name='';
             this.studiocaller.wss.close();
             document.location.reload(true);
            console.log('sign_out');
         }
      }
   }
</script>

<style>
   .comm_navbar {
      margin-bottom: 25px;
      position: relative;
   }
   .navmenu {
      float:right ;
   }
   .radio_name {
      height: 4px;
   }
   #mic_input {
      border: 1px solid black;
   }
   .mic_input {
      /* width: 100px; */
      /* height:20px; */
      float: left;
      transform: rotate(-180deg)  ;
      line-height: 0;
      margin-left: 10px;
      background-color: white;
      /* margin-right: 10px; */
   }
   .talk{
      color: #009600;
      font-size: 2rem;
   }
   .sign_out {
      cursor: default;
      display: flex;
      justify-content: center;
      align-items: center; 
      padding-left: 10px;
      padding-right: 10px;
      margin-left: 10px;
      border: 1px solid #cad2d970;
      padding: 5px;
   }
   .sign_out:hover {
      background-color: #cad2d92e;
   }
   .mic_text {
      float: left;
      margin-top: 90%;
   }
   #nav-collapse {
      line-height: 0; 
   }
   .mic_image {
      position: relative;
      display: block;
      float: left;
      bottom: -60px;
      left: 5px;
   }
   /* .navbar-nav {
      display: -webkit-inline-box;
   } */
   #nav-collapse {
      line-height: 1.5;
   }
</style>
